import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { REASON_MAX } from '../../../../../Consts/subscription-control.const';
import {
  TrialExtendDialogData,
  TrialExtendDialogResult,
} from '../../../Interfaces/subscription-dialog.interface';

@Component({
  selector: 'app-trial-extend-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, TranslateModule],
  templateUrl: './trial-extend-dialog.component.html',
  styleUrl: './trial-extend-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialExtendDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<TrialExtendDialogComponent, TrialExtendDialogResult>>(MatDialogRef);

  readonly data = inject<TrialExtendDialogData>(MAT_DIALOG_DATA);

  readonly reasonMax = REASON_MAX;

  readonly formGroup: FormGroup = this._formBuilder.group({
    trial_end: ['', [Validators.required]],
    reason: ['', [Validators.required, Validators.maxLength(REASON_MAX)]],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this._dialogRef.close({
      trialEnd: String(this.formGroup.value.trial_end),
      reason: String(this.formGroup.value.reason).trim(),
    });
  }

  dismiss(): void {
    this._dialogRef.close();
  }
}
